import { jsx as _jsx } from "react/jsx-runtime";
import { Root } from "./NotificationMenu.components.js";
import NotificationMenuHeader from "./components/Header.js";
import NotificationMenuMain from "./components/Main.js";
export const NotificationMenuMoleculeComponent = ({ header, slotProps, data, isLoading, ...props }) => {
    const slots = {
        header: NotificationMenuHeader,
    };
    return (_jsx(Root, { "data-testid": "NotificationMenu", slots: slots, slotProps: { header, root: slotProps?.paper }, ...props, children: _jsx(NotificationMenuMain, { data: data, isLoading: isLoading }) }));
};
export default NotificationMenuMoleculeComponent;
